import "./HelpIcon.css";

export default function HelpIcon() {
  return (
    <svg className="cod-help-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
      <circle className="cod-help-icon__background" cx="12" cy="12" r="11" />
      <path d="M9.5 8.75c0-1.4 1.05-2.25 2.5-2.25s2.5.85 2.5 2.25c0 1.1-.65 1.7-1.5 2.25-.7.45-1 1-1 1.9" stroke="#42474E" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="12" cy="16.5" r="1.25" fill="#42474E" />
    </svg>
  );
}
